import * as d3 from "d3";
import tooltip from "d3-tip";
import {
  getYAxisLabel,
  getChartData,
  getNoDataFoundLabel
} from "../../../utils/graph_service";
import { groupBarChartUtility } from "./groupBarChartUtility";

function stackedBarChartUtility(
  chartConfig,
  divId,
  onDrillDown,
  drillDownConfig,
  level,
  allowDrillDown
) {
  const chartNode = document.getElementById(divId);
  if (!chartConfig.data || !chartNode) return;
  if (chartNode !== null) {
    while (chartNode.firstChild) {
      chartNode.removeChild(chartNode.firstChild);
    }
  }
  const margin = { top: 20, right: 30, bottom: 35, left: 30 };
  let width = 400 - margin.left - margin.right;
  let height = 300 - margin.top - margin.bottom;

  if (chartNode.offsetWidth > 400) {
    width = chartNode.offsetWidth - margin.left - margin.right;
    height =
      chartNode.offsetHeight > height
        ? chartNode.offsetHeight - margin.top - margin.bottom
        : height;
  }
  RenderStackBarChart();

  /** render */
  function RenderStackBarChart() {
    const drillConfigData = drillDownConfig.config.find(
      x => x.level == level + 1
    );
    if (drillDownConfig.isDrillDown && allowDrillDown == true) {
      let config = {};
      if ((chartConfig.widgetconfig || {}).isForPerformance != true) {
        let resData = {};

        const drillDownColumnsConfig = { ...chartConfig.configuration };
        const filters = [];
        if (chartConfig.configuration.isRepeated == true) {
          filters.push({
            key: chartConfig.configuration.autoGenerate.key,
            values: [drillDownConfig.config.find(x => x.level == level + 1).key]
          });
          drillDownColumnsConfig.autoGenerate.filters = filters;
        } else {
          drillDownColumnsConfig.columns = [
            chartConfig.configuration.columns.find(
              x =>
                x.name ==
                [drillDownConfig.config.find(x => x.level == level + 1).key]
            )
          ];
        }

        resData = getChartData(
          chartConfig.rawData,
          drillDownColumnsConfig,
          drillConfigData.startDate,
          drillConfigData.endDate,
          drillConfigData.type
        );

        config = {
          startDate: chartConfig.startDate,
          endDate: chartConfig.endDate,
          configuration: drillDownColumnsConfig,
          rawData: chartConfig.rawData,
          data: resData.data,
          yAxisLabel: chartConfig.yAxisLabel,
          type: "GroupBarChart",
          keys: resData.barKeys,
          colors: resData.barColors,
          accessor: resData.chartAccessor.mainAccessor
        };
        groupBarChartUtility(
          config,
          divId,
          onDrillDown,
          drillDownConfig,
          level,
          allowDrillDown
        );
        if (drillDownConfig.currentLevel == level + 1) {
          drillDownConfig.isDrillDown = false;
        }
      } else {
        const drillConfigData = drillDownConfig.config.find(
          x => x.level == drillDownConfig.currentLevel
        );
        config = drillConfigData.performanceConfig;
        return generateStackChart(
          config.data,
          config.keys,
          config.colors,
          config.accessor,
          divId,
          chartConfig.yAxisLabel
        );
      }
    } else {
      return generateStackChart(
        chartConfig.data,
        chartConfig.keys,
        chartConfig.colors,
        chartConfig.accessor,
        divId,
        chartConfig.yAxisLabel
      );
    }
  }

  /** create stack chart based on parameters or information recieved by apis */
  function generateStackChart(data, keys, colors, accessor, divId, yAxisLabel) {
    const svg = d3
      .select("#" + divId)
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr(
        "height",
        height + margin.top + margin.bottom + margin.top + margin.bottom
      )
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    const x = d3
      .scaleBand()
      .range([margin.left, width])
      .padding(0.5);

    const y = d3.scaleLinear().rangeRound([height, 2]);

    // const xAxis = svg
    //   .append("g")
    //   .attr("transform", `translate(0,${height})`)
    //   .attr("class", "x-axis");

    // const yAxis = svg
    //   .append("g")
    //   .attr("transform", `translate(${margin.left},0)`)
    //   .attr("class", "y-axis");

    const z = d3
      .scaleOrdinal()
      .range(colors)
      .domain(keys);

    let totalCount = 0;

    data.forEach(function(d) {
      if ((chartConfig.widgetconfig || {}).isForPerformance == true) {
        d.total = d3.sum(keys, k => +parseFloat(d[k]).toFixed(2));
      } else {
        d.total = d3.sum(keys, k => +parseFloat(d[k]));
      }
      totalCount += d.total;
      return d;
    });

    y.domain([
      0,
      d3.max(data, d => d3.sum(keys, k => +parseFloat(d[k]).toFixed(2)))
    ]).nice();

    svg
      .selectAll(".y-axis")
      .transition()
      .duration(0)
      .style("color", "#000000")
      .style("font-family", "roboto")
      .style("font-weight", "500")
      .style("font-size", "10px")
      .call(d3.axisLeft(y).ticks(5))
      .call(g => g.select(".domain").style("color", "#252525"));

    x.domain(data.map(d => d[accessor]));

    if (totalCount == 0) {
      getNoDataFoundLabel(
        chartConfig.startDate + " to " + chartConfig.endDate,
        svg,
        height / 2,
        (width + margin.left + margin.right) / 2
      );
    }
    getYAxisLabel(yAxisLabel, svg, -15, 0 - height / 2);

    document.querySelectorAll(".tooltip" + divId).forEach(function(a) {
      a.remove();
    });
    const tip = tooltip()
      .attr("class", "d3-tip tooltip" + divId)
      .html(function(d) {
        return d;
      });
    svg.call(tip);

    svg
      .selectAll(".x-axis")
      .style("color", "#000000")
      .style("font-family", "roboto")
      .style("font-weight", "500")
      .style("font-size", "10px")
      .call(d3.axisBottom(x).tickSizeOuter(0))
      .call(g => g.select(".domain").style("color", "#000000"))
      .selectAll("text")
      .html("")
      .append("tspan")
      .text(function(d) {
        return d;
      })
      .each(wrap)
      .on("mouseover", () => {})
      .on("mouseout", () => {});

    const group = svg
      .selectAll("g.layer")
      .data(d3.stack().keys(keys)(data), d => d.key);

    group.exit().remove();

    group
      .enter()
      .append("g")
      .classed("layer", true)
      .attr("fill", d => z(d.key))
      .attr("key", d => d.key);

    const bars = svg
      .selectAll("g.layer")
      .selectAll("rect")
      .data(d => d, e => e.data[accessor])
      .attr("name", function(d) {
        d.key;
      });

    bars.exit().remove();

    bars
      .enter()
      .append("rect")
      .attr("width", x.bandwidth())
      .style("cursor", "pointer")
      .on("mouseover", function(d) {
        const tipData =
          d.data[accessor] +
          ": " +
          this.parentElement.getAttribute("key") +
          ((chartConfig.widgetconfig || {}).isForPerformance == true
            ? " value " +
              parseFloat(d[1])
                .toFixed(2)
                .toLocaleString()
            : " count " + d[1]);
        tip.show(tipData, this);
      })
      .on("mouseout", tip.hide)
      .on("click", function(d) {
        tip.hide(d, this);
        let type = "Month";
        if ((chartConfig.widgetconfig || {}).isForPerformance == true) {
          level = drillDownConfig.currentLevel;
          type = accessor == "YTD" ? "Month" : "Day";
        }
        onDrillDown(
          true,
          this.parentElement.getAttribute("key"),
          type,
          d.data[accessor],
          level + 1,
          d.data.seriesItem
        );
      })
      .merge(bars)
      .transition()
      .duration(0)
      .attr("x", d => x(d.data[accessor]))
      .attr("y", d => y(d[1]))
      .attr("height", d => y(d[0]) - y(d[1]));

    if (drillDownConfig.currentLevel > 1) {
      let type = "Month";
      if ((chartConfig.widgetconfig || {}).isForPerformance == true) {
        level = drillDownConfig.currentLevel;
        type = "YTD";
        allowDrillDown = true;
      }
      svg
        .append("svg")
        .style("fill", "#07406d")
        .style("cursor", "pointer")
        .attr("y", -10)
        .attr("x", -10)
        .append("path")
        .attr(
          "d",
          "M22 3H7c-.69 0-1.23.35-1.59.88L.37 11.45c-.22.34-.22.77 0 1.11l5.04 7.56c.36.52.9.88 1.59.88h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3.7 13.3c-.39.39-1.02.39-1.41 0L14 13.41l-2.89 2.89c-.39.39-1.02.39-1.41 0a.9959.9959 0 010-1.41L12.59 12 9.7 9.11a.9959.9959 0 010-1.41c.39-.39 1.02-.39 1.41 0L14 10.59l2.89-2.89c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41L15.41 12l2.89 2.89c.38.38.38 1.02 0 1.41z"
        )
        .on("click", function() {
          //alert("jj");
          onDrillDown(false, drillDownConfig.key, type, "", level);
        });
    }

    let legendLine = 10;
    let currentX = 0;
    const legend = svg
      .append("g")
      .attr("class", "legend-container")
      .attr("height", 150)
      .attr("width", width)
      .attr("class", "bottom-row")
      .attr("transform", "translate(" + 20 + ", " + (height + 40) + ")");
    legend
      .selectAll("g")
      .data(keys)
      .enter()
      .append("g")
      .each(function(d) {
        const g = d3.select(this);
        let y = legendLine;
        const rect = g
          .append("rect")
          .attr("y", y)
          .attr("x", currentX)
          .attr("width", 10)
          .attr("height", 10)
          .attr("class", d.replace(/[^a-zA-Z0-9]/g, "") + " legend")
          .style("fill", z(d));

        const size = rect.node().getBBox();
        currentX += size.width + 10;
        if (currentX > width) {
          currentX = 0;
          legendLine += 30;
          y = legendLine;
          rect.attr("x", currentX).attr("y", y);
          currentX += size.width + 10;
        }
        const recText = g
          .append("text")
          .attr("y", y + 10)
          .attr("x", currentX)
          .attr("height", 30)
          .attr("width", 170)
          .attr("class", d.replace(/[^a-zA-Z0-9]/g, "") + " legend")
          .style("fill", z(d))
          .style("font-family", "roboto")
          .style("font-weight", "500")
          .style("font-size", "12px")
          .text(d);
        const recTextSize = recText.node().getBBox();
        currentX += recTextSize.width + 20;
        if (currentX > width) {
          currentX = 0;
          legendLine += 30;
          y = legendLine;
          rect.attr("x", currentX).attr("y", y);
          currentX += size.width + 10;
          recText.attr("x", currentX).attr("y", y + 10);
          currentX += recTextSize.width + 20;
        }
      });
  }
  function wrap() {
    const self = d3.select(this);
     let textLength = self.node().getComputedTextLength(),
      text = self.text();
    while (textLength > 70 && text.length > 0) {
      text = text.slice(0, -1);
      self.text(text + "...");
      textLength = self.node().getComputedTextLength();
    }
  }
}
export { stackedBarChartUtility };
